export const TAB_VIEW_LIST = "list";
export const TAB_VIEW_DETAILS = "details";
export const TAB_VIEW_DOCUMENTS = "documents";

export const MISC_ANALYSIS_TABS = {
  DETAILS: "details",
  DOCUMENTS: "documents",
};

export const MISC_ANALYSIS_SORT_OPTIONS = {
  NAME: "name",
  CREATED_DATE: "created_date",
  CREATED_BY: "created_by",
  UPDATED_DATE: "updated_date",
};

export const MISC_ANALYSIS_SORT_ORDER = {
  ASC: "ASC",
  DESC: "DESC",
};
